module.exports = __webpack_public_path__ + "static/img/wenhuajingying.f5f3976.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wenhuajingying.png
// module id = nE8j
// module chunks = 18